import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import AllocationList from './AllocationList'
import ActionNewReportButton from '../../report/view/ActionNewReportButton'

const AllocationCategory = ({ claimType, categoryIsLoading, categoryData, showAll }) => {
  return (
    <Box>
      <Typography color="dark-text.main" marginBottom={1}>
        {claimType} claim
      </Typography>
      <Box display={'flex'} flexDirection={'column'} rowGap={2}>
        {categoryIsLoading && categoryData?.length > 0 ? (
          <AllocationList isLoading />
        ) : (
          categoryData
            // .filter((list) => list.allocated !== null && list.claim_type === claimType)
            .filter((list) =>
              showAll
                ? list.claim_type === claimType
                : list.allocated !== null && list.claim_type === claimType
            )
            .sort((a, b) => {
              if (a.allocated === null) return 1   // push "as incurred" to bottom
              if (b.allocated === null) return -1
              return b.allocated - a.allocated
            })
            .map((list, index) => (
              <ActionNewReportButton
                key={index}
                selectedCategory={list}
              // clickable={list.allocated !== 0}
              >
                <AllocationList
                  key={list.id}
                  type={list.name}
                  // muiIcon={list.muiIcon}
                  amountBalance={list.allocated}
                  amountAllocation={list.allocation}
                  isAsIncurred={list.allocated === null}
                  cyclePeriod={list.cycle_period}
                />
              </ActionNewReportButton>
            ))
        )}
      </Box>
    </Box>
  )
}

const AllocationPanel = ({ categoryIsLoading, categoryData }) => {

  // const isAvailable = (type) =>
  //   categoryData?.categories?.filter((list) => list.allocated !== null && list.claim_type === type)
  //     .length > 0

  const isAvailable = (type) => {
    if (type === 'General') {
      return categoryData?.categories?.filter((list) => list.claim_type === type).length > 0
    }
    return categoryData?.categories?.filter(
      (list) => list.allocated !== null && list.claim_type === type
    ).length > 0
  }

  return (
    <Box
      sx={{
        width: 1,
        p: 2,
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
        bgcolor: 'white.main',
        boxSizing: 'border-box',
      }}
    >
      <Typography variant="body1" fontWeight="bold" color="dark-text.main">
        My allocation balance
      </Typography>
      <Typography variant="body2" marginBottom={4} color="light-gray-text.main">
        Your claim allocation balance for the current year
      </Typography>

      {!categoryIsLoading && (
        <Box
          display={'flex'}
          flexDirection={'column'}
          rowGap={3}
          maxHeight={'calc(100vh - 236px)'}
          overflow={'auto'}
          className="scrollbar"
        >
          {isAvailable('General') && (
            <AllocationCategory
              claimType="General"
              categoryIsLoading={categoryIsLoading}
              categoryData={categoryData?.categories}
              showAll
            />
          )}
          {isAvailable('Mileage') && (
            <AllocationCategory
              claimType="Mileage"
              categoryIsLoading={categoryIsLoading}
              categoryData={categoryData?.categories}
            />
          )}
        </Box>
      )}
    </Box>
  )
}

export default AllocationPanel
